import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DashboardServicesService } from 'src/app/_services/dashboard-services.service';
import { RejectedApprovedDialogComponent } from '../rejected-approved-dialog/rejected-approved-dialog.component';
import { SuccessApprovedDialogComponent } from '../success-approved-dialog/success-approved-dialog.component';

@Component({
  selector: 'app-reviewspiritualfitness',
  templateUrl: './reviewspiritualfitness.component.html',
  styleUrls: ['./reviewspiritualfitness.component.css']
})
export class ReviewspiritualfitnessComponent implements OnInit {
  tvProgramFileTypeParams: any;
  cmsHistorySpiritual: any = 'spiritual';
  status: any = 'pending';
  cmsSpirtiualData: any;
  statusParams: any;
  statusApprove: any = 'approved';
  Loader: boolean;
  declineParams: { status: any };
  rejectstatus: any = 'rejected';
  role:any = 'superAdmin';

  constructor(
    private services: DashboardServicesService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {

    this.role = localStorage.getItem('ROLE');
    this.tvProgramFileTypeParams = {
      fileType: this.cmsHistorySpiritual,
      status: this.status,
    };
    this.services
      .cmsHistoryTvProgramSection(this.tvProgramFileTypeParams)
      .subscribe((data) => {
        this.cmsSpirtiualData = data.data;
      });
  }
  create(id: any, i: any) {
    this.statusParams = {
      status: this.statusApprove,
    };
    this.Loader = true;
    this.services.superAdminReview(id, this.statusParams).subscribe((res) => {
      setTimeout(() => {
        this.Loader = false;
        this.cmsSpirtiualData.splice(i, 1);
        this.dialog.open(SuccessApprovedDialogComponent, {
          disableClose: true,
        });
      }, 1000);
    });
  }
  reject(id: any, i: any) {
    this.declineParams = {
      status: this.rejectstatus,
    };
    this.Loader = true;

    this.services.superAdminReview(id, this.declineParams).subscribe((res) => {
      this.cmsSpirtiualData.splice(i, 1);
      setTimeout(() => {
        this.Loader = false;
        this.dialog.open(RejectedApprovedDialogComponent, {
          disableClose: true,
        });
      }, 1000);
    });
  }

  downloadFile(key:any){
     window.open('https://calvary-backend.s3.amazonaws.com/'+key);
  }
}

